import { useSyncExternalStore } from 'react';

import { getToast, subscribeToToast, type ToastTone } from '../lib/toast';

const TONE_CLASS: Record<ToastTone, string> = {
  ok: 'call-emerald',
  warn: 'call-orange',
  neutral: 'call-slate',
};

/** The single subscriber to the toast store. Mounted once, at the app root. */
export function Toaster() {
  const toast = useSyncExternalStore(subscribeToToast, getToast, getToast);
  if (toast === null) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 26,
        transform: 'translateX(-50%)',
        zIndex: 90,
        animation: 'toastIn .18s ease-out',
      }}
    >
      <div
        key={toast.id}
        className={TONE_CLASS[toast.tone]}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '11px 16px',
          borderRadius: 10,
          borderWidth: 1,
          borderStyle: 'solid',
          boxShadow: 'var(--elev-pop)',
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        <span
          style={{ width: 7, height: 7, borderRadius: 999, background: 'currentColor', flex: 'none' }}
          aria-hidden="true"
        />
        <span>{toast.message}</span>
      </div>
    </div>
  );
}
